export class VisitorBookingConstants {
  public static ReferenceNumber: string = "ref";
}